var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('vue-good-table',{staticClass:"mx-4",attrs:{"columns":_vm.columns,"rows":_vm.getBrandList,"line-numbers":false,"sort-options":{
        enabled: true,
        initialSortBy: {field: 'name', type: 'asc'}
      },"search-options":{enabled: true,}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return undefined}}])},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("There are no entries")]),_c('div',{attrs:{"slot":"table-actions"},slot:"table-actions"}),_vm._v(" > ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }